import { render, staticRenderFns } from "./countDowns.vue?vue&type=template&id=671ed61a&scoped=true"
import script from "./countDowns.vue?vue&type=script&lang=js"
export * from "./countDowns.vue?vue&type=script&lang=js"
import style0 from "./countDowns.vue?vue&type=style&index=0&id=671ed61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ed61a",
  null
  
)

export default component.exports